/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where can I use the regex?`)
};

const es_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Dónde puedo usar la expresión regular?`)
};

const de_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wo kann ich den Regex verwenden?`)
};

const nl_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar kan ik de regex gebruiken?`)
};

const fr_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Où puis-je utiliser la regex ?`)
};

const it_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dove posso usare l'espressione regolare?`)
};

const pt_br2_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde posso usar a regex?`)
};

const pt_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onde posso usar a regex?`)
};

const ja_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正規表現はどこで使えますか？`)
};

const zh_iupac_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个正则表达式可以用在哪里？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_q3", locale)
	if (locale === "en") return en_iupac_faq_q3(inputs)
	if (locale === "es") return es_iupac_faq_q3(inputs)
	if (locale === "de") return de_iupac_faq_q3(inputs)
	if (locale === "nl") return nl_iupac_faq_q3(inputs)
	if (locale === "fr") return fr_iupac_faq_q3(inputs)
	if (locale === "it") return it_iupac_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_q3(inputs)
	if (locale === "pt") return pt_iupac_faq_q3(inputs)
	if (locale === "ja") return ja_iupac_faq_q3(inputs)
	return zh_iupac_faq_q3(inputs)
};